module.exports = {
  baseUrl: 'https://www.rongfanjs.com/',
  onlineUrl: 'https://www.rongfanjs.com/',
  projectName: '苏州荣帆建设工程办公系统',
  filingNumber: '苏ICP备20044537号-3'
}
